export default __webpack_public_path__ + "static/project-3-36458ffb53eef650daf31aa5e56df46d.png";